var map = {
	"./Sent Mail.svg": "78c6",
	"./add-activity.svg": "ac38",
	"./checkDisabledMail.svg": "1285",
	"./del.svg": "4a45",
	"./delete.svg": "94e5",
	"./edit.svg": "186b",
	"./empty.svg": "521a",
	"./exam.svg": "1f9b",
	"./file.svg": "3441",
	"./history.svg": "d8a5",
	"./link.svg": "9ee4",
	"./more.svg": "492b",
	"./move.svg": "4168",
	"./music.svg": "b40e",
	"./online.svg": "12db",
	"./pdf.svg": "5a0d",
	"./plus.svg": "dc29",
	"./reply.svg": "e1eb",
	"./rexam.svg": "7d11",
	"./rfile.svg": "f338",
	"./rlink.svg": "0a40",
	"./ronline.svg": "a2ea",
	"./rpdf.svg": "63f3",
	"./rsurvey.svg": "b87c",
	"./rtrain.svg": "1bce",
	"./rvideo.svg": "d51c",
	"./survey.svg": "1a75",
	"./table-down.svg": "ac45",
	"./train.svg": "7fc2",
	"./video.svg": "fb5b",
	"./view.svg": "cea9",
	"./warning.svg": "96ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9256";